<select class="form-control"
        (ngModelChange)="onChangeCb($event)"
        [required]="required"
        [disabled]="disabled"
        [(ngModel)]="selected">
  <option [value]=""></option>
  <option *ngFor="let country of countryOrderedOptions" [value]="country.key">{{country.value}}</option>
</select>
